import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { ChangePasswordRepository } from '../../../data/repositories/change-password-repository'
import type { ChangePasswordRequest } from '../../../domain/models/change-password'
import { ChangePasswordService } from '../../../service/change-password-service'
import { ChangePasswordController } from '../../controllers/change-password-controller'
import * as action from '../actions/change-password-action'

export const controller = async (payload: { params: ChangePasswordRequest; jwtToken?: string }) => {
  const { key, token } = await makeAccess()
  const dataSource = new ChangePasswordService(apiConfig(key, token))
  const repository = new ChangePasswordRepository(dataSource)
  const control = new ChangePasswordController(repository)
  return await control.create(payload.params, payload.jwtToken)
}

export function* changePasswordSaga({ payload }: any): any {
  try {
    const result: boolean = yield call(controller, payload)
    yield put(action.changePasswordSuccess(result))
  } catch (error: any) {
    yield put(action.changePasswordError(error.toString()))
  }
}
